

import api from "@/api/axios/axios.js";

export async function deleteProyecto(projectKey, apiPrefix,data1) {
    if (!projectKey) return { ok: false, error: "No_Key" };
    try {
        const url = `${apiPrefix
            }/proyectos/${encodeURIComponent(projectKey)}/delete/`;

        const resp = await api.delete(url, {data:data1});

      
        const data = await resp.data;
        return {
            ok: true,
            status: resp.status,
            data: data
        }
    } catch (err) {
        return {
            ok: false,
            status: err.response?.status,
            data: err.response?.data
        }
    }
}
export async function getUnitBussines() {
    const resp = await api.get("/login/unit-bussines/");
    return resp.data;
}

export async function getProjectsForTeams(params = { chatgpt: false }) {
    const resp = await api.get("/login/proyects/forteams", { params });
    return resp.data;
}

export async function getProyectoDetail(projectKey) {
    const resp = await api.get(`/login/proyectos/detail/${encodeURIComponent(projectKey)}/`);
    return resp.data;
}

export async function createProyecto(payload) {
    const resp = await api.post("/login/proyectos/", payload);
    return resp.data;
}

export async function updateProyecto(projectKey, payload) {
    const resp = await api.put(`/login/proyectos/${encodeURIComponent(projectKey)}/`, payload);
    return resp.data;
}

export async function patchProyecto(projectKey, payload) {
        const resp = await api.patch(`/login/proyectos/${encodeURIComponent(projectKey)}/`, payload);
        return resp.data;
    }
export async function getResponsables() {
    const resp = await api.get("/login/responsibility/");
    return resp.data;
}
export async function getProjectsChatGPT() {
    const resp = await api.get("/login/proyectos/", { params: { chatgpt: true } });
    return resp.data;
}

export async function getPermissionsProyects(){
    const resp =await api.get("/login/permissionModels/proyects")
    return resp;
}